import React from 'react';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { ExtendedInfoSVG } from '../../../../_lib/components/ExtendedInfo';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Icons } from '../../../../components/atoms/SVG';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { EmailStatus } from '../views/ChangeAccessLevelDefaultView';
import { formatDate, TimeFormats } from '../../../../lib/DateFormat';
import { ExtendedInfoModifier } from '../../../../_lib/components/ExtendedInfo/partials/ExtendedInfo';

type EmailRequestStatusProps = {
  emailStatus: EmailStatus;
};

export function EmailRequestStatus({ emailStatus }: EmailRequestStatusProps) {
  const { t } = useSonTranslation('AccessLevel');
  const { emailState, emailSentDate } = emailStatus;

  const getStatusText = () => {
    if (emailState === 'notSend') {
      return t('emailRequestStatus.notSent');
    }
    if (emailState === 'byAdmin' && emailSentDate) {
      return t('emailRequestStatus.sentByAdmin', {
        date: formatDate(emailSentDate, TimeFormats.DAY_MONTH_YEAR) as string,
      });
    }
    if (emailState === 'automatically' && emailSentDate) {
      return t('emailRequestStatus.autoSent', {
        date: formatDate(emailSentDate, TimeFormats.DAY_MONTH_YEAR) as string,
      });
    }
  };

  return (
    <div className="access-level__email-request-status">
      <Heading hierarchy={5}>{t('emailRequestStatus.headline')}</Heading>
      <div className="access-level__email-request-status-text-container font-regular-15-21">
        {emailState === 'notSend' && (
          <ExtendedInfoSVG
            helpText={t('emailRequestStatus.helpText')}
            tooltipPlacement={TooltipPlacement.TOP}
            svgSpriteID={Icons.FEEDBACK_ERROR}
            modifier={ExtendedInfoModifier.RED}
          />
        )}
        {getStatusText()}
      </div>
    </div>
  );
}
